import StatusScreenScaffold from "../../../../components/layout/StatusScreenScaffold";
import { StatusScreenType } from "../../../../components/layout/StatusScreenScaffold/types";

function ProposalValidToken() {
  return (
    <StatusScreenScaffold
      title="Token validado!"
      subtitle="Você validou o token com sucesso."
      subtitleMaxWidth={180}
      type={StatusScreenType.success}
    />
  );
}
export default ProposalValidToken;
